export default "__VITE_ASSET__7VoAz$A3__"